
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-use",
      function () {
        return require("private-next-pages/terms-use/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-use"])
      });
    }
  